module.exports = __webpack_public_path__ + "img/daihatsu.66300d09.png";